import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import { initPlausible } from './lib/plausible';
import './i18n';
import './index.css';

// Load privacy-friendly analytics (no-op unless VITE_PLAUSIBLE_SRC is set).
initPlausible();

const container = document.getElementById('root');
if (!container) throw new Error('Root container #root not found');

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
